import * as Axios from 'axios';
import { isNil } from 'lodash';

class AxiosFactory {

    constructor()
    {
        this.instance = null;
        Axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest'
        };
    }

    get ()
    {
        if (this.instance)
        {
            return this.instance;
        }

        const headers = {};

        const CSRF = $('meta[name="csrf-token"]');
        if (!isNil(CSRF))
        {
            headers['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');
            // throw new Error('le `csrf-token` est introuvable.');
        }

        if (!isNil(window.MSP_municipalityID))
        {
            headers['X-MSP-MUNICIPALITY-ID'] = window.MSP_municipalityID;
            // throw new Error('le paramètre `municipalityID` est introuvable.');
        }

        this.instance = Axios.create({headers});

        return this.instance;
    }
}

const axiosFactory = new AxiosFactory();
export { axiosFactory }



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/axios-factory.js